import type { WordPackDefinition } from "./types";

// Science pack - chemistry, physics, biology, medicine
export const SCIENCE_WORDS = [
  // Chemistry
  "ATOM", "MOLECULE", "ELEMENT", "COMPOUND", "ELECTRON", "PROTON", "NEUTRON", "ION", "ISOTOPE", "BOND",
  "ACID", "BASE", "CATALYST", "REACTION", "SOLUTION", "CRYSTAL", "POLYMER", "ENZYME", "PROTEIN", "DNA",
  "CARBON", "OXYGEN", "NITROGEN", "HYDROGEN", "HELIUM", "SODIUM", "CHLORINE", "SULFUR", "PHOSPHORUS", "CALCIUM",
  "FORMULA", "PERIODIC", "LABORATORY", "BEAKER", "FLASK", "BURNER", "PIPETTE", "CENTRIFUGE", "SPECTROMETER", "TITRATION",
  // Physics
  "GRAVITY", "FORCE", "MASS", "ENERGY", "VELOCITY", "MOMENTUM", "FRICTION", "PRESSURE", "DENSITY", "VOLUME",
  "WAVE", "FREQUENCY", "AMPLITUDE", "PHOTON", "QUANTUM", "PARTICLE", "FIELD", "MAGNET", "CURRENT", "VOLTAGE",
  "CIRCUIT", "CONDUCTOR", "RESISTOR", "CAPACITOR", "TRANSISTOR", "SEMICONDUCTOR", "LASER", "PRISM", "LENS", "SPECTRUM",
  "RELATIVITY", "ENTROPY", "THERMODYNAMICS", "KINETIC", "POTENTIAL", "NUCLEAR", "FUSION", "FISSION", "RADIATION", "DECAY",
  // Biology
  "CELL", "NUCLEUS", "MEMBRANE", "CHROMOSOME", "GENE", "RNA", "VIRUS", "BACTERIA", "FUNGUS", "PARASITE",
  "ORGAN", "TISSUE", "MUSCLE", "NERVE", "BONE", "BLOOD", "HEART", "BRAIN", "LUNG", "LIVER",
  "SPECIES", "EVOLUTION", "MUTATION", "ADAPTATION", "HABITAT", "ECOSYSTEM", "PREDATOR", "PREY", "SYMBIOSIS", "EXTINCTION",
  "PHOTOSYNTHESIS", "RESPIRATION", "METABOLISM", "DIGESTION", "IMMUNE", "ANTIBODY", "VACCINE", "HORMONE", "NEURON", "SYNAPSE",
  // Medicine
  "DOCTOR", "SURGEON", "NURSE", "PATIENT", "DIAGNOSIS", "SYMPTOM", "TREATMENT", "THERAPY", "PRESCRIPTION", "DOSE",
  "INJECTION", "TRANSFUSION", "TRANSPLANT", "SURGERY", "BIOPSY", "SCAN", "XRAY", "MRI", "ULTRASOUND", "STETHOSCOPE",
  "PHARMACY", "ANTIBIOTIC", "PAINKILLER", "ANESTHETIC", "SEDATIVE", "STIMULANT", "STEROID", "INSULIN", "ADRENALINE", "DOPAMINE",
  // Scientific Method
  "HYPOTHESIS", "THEORY", "EXPERIMENT", "OBSERVATION", "DATA", "ANALYSIS", "RESULT", "CONCLUSION", "VARIABLE", "CONTROL",
  "SAMPLE", "MEASURE", "CALIBRATE", "REPLICATE", "PEER REVIEW", "PUBLICATION", "CITATION", "BREAKTHROUGH", "DISCOVERY", "INVENTION",
];

export const SCIENCE_SEMANTIC_FAMILIES: string[][] = [
  ["ATOM", "MOLECULE", "ELEMENT", "COMPOUND", "ION", "ISOTOPE", "PROTON", "NEUTRON", "ELECTRON"],
  ["ACID", "BASE", "REACTION", "CATALYST", "SOLUTION", "CRYSTAL", "POLYMER"],
  ["LABORATORY", "BEAKER", "FLASK", "BURNER", "PIPETTE", "CENTRIFUGE", "SPECTROMETER", "TITRATION"],
  ["GRAVITY", "FORCE", "MASS", "ENERGY", "VELOCITY", "MOMENTUM", "FRICTION", "PRESSURE", "DENSITY", "VOLUME"],
  ["CURRENT", "VOLTAGE", "CIRCUIT", "CONDUCTOR", "RESISTOR", "CAPACITOR", "TRANSISTOR", "SEMICONDUCTOR", "LASER", "SPECTRUM"],
  ["CELL", "DNA", "GENE", "RNA", "VIRUS", "BACTERIA", "MUTATION", "EVOLUTION", "ECOSYSTEM", "IMMUNE"],
  ["HEART", "BRAIN", "LUNG", "LIVER", "BLOOD", "BONE", "MUSCLE", "NERVE", "TISSUE", "ORGAN"],
  ["DOCTOR", "SURGEON", "NURSE", "PATIENT", "DIAGNOSIS", "TREATMENT", "THERAPY", "PRESCRIPTION", "PHARMACY", "VACCINE", "ANTIBODY"],
  ["HYPOTHESIS", "THEORY", "EXPERIMENT", "OBSERVATION", "DATA", "ANALYSIS", "RESULT", "CONCLUSION", "VARIABLE", "CONTROL", "SAMPLE", "MEASURE"],
];

export const SCIENCE_PACK: WordPackDefinition = {
  key: "science",
  words: SCIENCE_WORDS,
  semanticFamilies: SCIENCE_SEMANTIC_FAMILIES,
};
